import React from "react";

/** Incoming (orders from partners): an inbox tray with an arrow coming in. */
const IncomingIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 3v9m0 0-3.2-3.2M12 12l3.2-3.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.5 14h4.6l1.4 2.5h5l1.4-2.5h4.6" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
      <path d="M3.5 14v4.5A1.5 1.5 0 0 0 5 20h14a1.5 1.5 0 0 0 1.5-1.5V14l-2.2-6H17M3.5 14l2.2-6H7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default IncomingIcon;
